import React from 'react';
import { Redirect } from 'react-router-dom';
import { createOidcAuthenticationComponent } from '@cp-shared-19/frontend-ui';
import { landingPagePath } from '../../components/navigation/paths';

export const Authentication = createOidcAuthenticationComponent({
    onMissingAuthentication: <Redirect to={landingPagePath()} />,
});
